{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "core/term-template",
	"title": "Term Template",
	"category": "theme",
	"ancestor": [ "core/terms-query" ],
	"description": "Contains the block elements used to render a taxonomy term, like the name, description, and more.",
	"textdomain": "default",
	"usesContext": [ "termQuery" ],
	"supports": {
		"anchor": true,
		"reusable": false,
		"html": false,
		"align": [ "wide", "full" ],
		"layout": true,
		"color": {
			"gradients": true,
			"link": true,
			"__experimentalDefaultControls": {
				"background": true,
				"text": true
			}
		},
		"typography": {
			"fontSize": true,
			"lineHeight": true,
			"__experimentalFontFamily": true,
			"__experimentalFontWeight": true,
			"__experimentalFontStyle": true,
			"__experimentalTextTransform": true,
			"__experimentalTextDecoration": true,
			"__experimentalLetterSpacing": true,
			"__experimentalDefaultControls": {
				"fontSize": true
			}
		},
		"spacing": {
			"margin": true,
			"padding": true,
			"blockGap": {
				"__experimentalDefault": "1.25em"
			},
			"__experimentalDefaultControls": {
				"blockGap": true,
				"padding": false,
				"margin": false
			}
		},
		"interactivity": {
			"clientNavigation": true
		},
		"__experimentalBorder": {
			"radius": true,
			"color": true,
			"width": true,
			"style": true
		}
	},
	"style": "wp-block-term-template",
	"editorStyle": "wp-block-term-template-editor"
}
